import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  tableCellClasses,
} from "@mui/material";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { styled } from "@mui/material/styles";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const abNumber = [
  { value: "3912097", label: "3912097" },
  { value: "3915291", label: "3915291" },
  { value: "3765803", label: "3765803" },
  { value: "3765802", label: "3765802" },
  { value: "3765800", label: "3765800" },
];

const commissionName = [
  { value: "HT010912-NK-B2-5F-H202307QR0052_CY-YU1", label: "HT010912-NK-B2-5F-H202307QR0052_CY-YU1" },
  { value: "HT018216-NK-H202108QR0063-B12F_XER PRJ", label: "HT018216-NK-H202108QR0063-B12F_XER PRJ" },
  { value: "HT018603-NK-J202107QR0015-A1-2F", label: "HT018603-NK-J202107QR0015-A1-2F" },
  { value: "HT018604-NK-J202107QR0015-A1-3F", label: "HT018604-NK-J202107QR0015-A1-3F" },
  { value: "HT018605-NK-J202107QR0015-A1-4F", label: "HT018605-NK-J202107QR0015-A1-4F" },
];

const orderCategoryOptions = [
  { value: "SHR", label: "SHR" },
  { value: "MOU", label: "MOU" },
  { value: "RET", label: "RET" },
  { value: "PRJ", label: "PRJ" },
  { value: "MISC", label: "MISC" },
];

const BasicInfo = () => {
  const [orderCategoryValue, setOrderCategoryValue] = useState();
  const [qtyValue, setQtyValue] = useState(1);

  const handleChangeOrderCategory = (event) => {
    setOrderCategoryValue({
      value: event.value,
      label: event.label,
    });
  };
  const handleQtyChange = (event) => {
    setQtyValue(Number(event.target.value));
  };
  return (
    <Container component="main" maxWidth="md" sx={{ py: 3 }}>
      <Grid container className="mb-16">
        <Grid container spacing={2} className="mb-16">
          <Grid item xs={4}>
            <label className="pb-8 block">Customer</label>
            <TextField
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={4}>
            <label className="pb-8 block">Showroom</label>
            <Select
              required
              // options={sortOptions}
              styles={customStyles()}
              className="w-full"
            />
          </Grid>
          <Grid item xs={4}>
            <label className="pb-8 block">Hubspot reference Uniq ID</label>
            <Select
              required
              // options={sortOptions}
              styles={customStyles()}
              className="w-full"
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mb-16">
          <Grid item xs={4}>
            <label className="pb-8 block">Product</label>
            <Select
              required
              // options={sortOptions}
              styles={customStyles()}
              className="w-full"
            />
          </Grid>
          <Grid item xs={4}>
            <label className="pb-8 block">Order Category</label>
            <Select
              required
              value={orderCategoryValue}
              options={orderCategoryOptions}
              styles={customStyles()}
              className="w-full"
              onChange={handleChangeOrderCategory}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mb-16">
          <Grid item xs={3}>
            <label className="pb-8 block">Order Reference</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={3}>
            <label className="pb-8 block">Type Number</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={3}>
            <label className="pb-8 block">Unique ID</label>
            <TextField
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={3}>
            {orderCategoryValue?.value === "PRJ" ? (
              <>
                <label className="pb-8 block">Qty</label>
                <TextField
                  name="customer"
                  fullWidth
                  variant="outlined"
                  type="number"
                  value={qtyValue}
                  onChange={handleQtyChange}
                />
              </>
            ) : (
              <>
                <label className="pb-8 block">Client Name</label>
                <TextField
                  required
                  name="customer"
                  fullWidth
                  variant="outlined"
                  type="text"
                />
              </>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mb-16">
          {orderCategoryValue?.value !== "PRJ" && <Grid item xs={6}>
            <label className="pb-8 block">Commission Name</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>}
        </Grid>

        <Grid container spacing={2} className="mb-16">
          {orderCategoryValue?.value === "PRJ" && (
            <Grid item xs={12}>
              <TableContainer component={Paper} sx={{
                maxHeight: 450,
                bgcolor: "background.paper",
              }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>SL.No</StyledTableCell>
                      <StyledTableCell>Unique ID</StyledTableCell>
                      <StyledTableCell>Commission Name</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array(qtyValue)
                      .fill(0)
                      .map((x, id) => (
                        <StyledTableRow key={id}>
                          <StyledTableCell>{id + 1}</StyledTableCell>
                          <StyledTableCell>Unique ID</StyledTableCell>
                          <StyledTableCell>Commission Name</StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          )}
        </Grid>

        <Grid container spacing={2} className="mb-16">
          <Grid item xs={4}>
            <label className="pb-8 block">WGI List Price (Euros)</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={4}>
            <label className="pb-8 block">WG2 List Price (Euros)</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={4}>
            <label className="pb-8 block">Total List Price (Euros)</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mb-16">
          <Grid item xs={4}>
            <label className="pb-8 block">Volume(cbm)</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={4}>
            <label className="pb-8 block">Weight (kg)</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
        </Grid>

      </Grid>
    </Container>
  );
};

export default BasicInfo;
